import React from "react";
import { date_to_display_for_messages } from "../../../utils/constant";
import { useAuth } from "../../../hooks/useAuth";
import CustomPopover from "../../general/CustomPopover";

export default function MessageCard(props) {
  const { message, handleAgreeDelete, handleEdit } = props;
  const { userInfo } = useAuth();
  const isSent = message.sender?.id === userInfo.id;

  const menuOptions = (message) => {
    const MENU_OPTIONS = [];
    if (isSent) {
      MENU_OPTIONS.push(
        {
          label: "Edit",
          icon: "akar-icons:edit",
          handleClick: handleEdit,
        },
        {
          label: "Delete",
          icon: "ant-design:delete-twotone",
          handleClick: handleAgreeDelete,
        }
      );
    }

    return MENU_OPTIONS;
  };

  return (
    <div className="text-end">
      <CustomPopover
        menu={menuOptions(message)}
        data={message}
        isHorizontal={true}
      />
      <div
        className={`d-flex mb-2 ${
          isSent ? "justify-content-end" : "justify-content-start"
        }`}
      >
        <div
          className={`p-2 rounded message-bubble text-start ${
            isSent ? "sent" : "received"
          }`}
        >
          {message.content}
          <div className="text-end text-muted small mt-1">
            {date_to_display_for_messages(message.created_at)}
          </div>
        </div>
      </div>
    </div>
  );
}
